const Footer = () => {
  return (
    <footer className=" text-center text-white bottom-0 left-0 fixed w-full ">
      <div
        className="p-4 text-center"
        style={{ backgroundColor: "#1a237e" }}
      >
        © 2023 created  by Hakan  
    
      </div>
    </footer>
  );
};

export default Footer;
